<template>
  <v-dialog v-model="dialog" persistent>
    <v-card>
      <!-----------------------------------------TITLE BAR----------------------------------------->
      <v-card-title class="redColor d-flex">
        <!--TITLE-->
        <span class="headline text-white">
          {{ partID }}
        </span>

        <v-spacer />

        <!--CLOSE BUTTON-->
        <v-btn variant="solo" icon large color="white" @click="close">
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </v-card-title>
      <!-------------------------------------------FORM-------------------------------------------->
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <div class="container">
            <v-row>
              <!-------------------------------------SHIPMENT-------------------------------------->
              <v-col cols="12" sm="6" lg="6">
                <v-select
                  v-model="part.shipment_id"
                  :items="shipments"
                  :label="$t('parts.inventory.form.shipment')"
                  color="red-darken-1"
                  variant="solo"
                  item-title="name"
                  item-value="_id"
                  readonly
                />
              </v-col>
              <!------------------------EXTERNAL COLOR------------------------------------->
              <v-col cols="12" sm="3" lg="3">
                <v-text-field
                  v-model="externalColor"
                  :label="$t('vehicle_entry.info.external_color')"
                  variant="solo"
                  readonly
                />
              </v-col>
              <!-------------------------------------EBAY CODE------------------------------------->
              <v-col cols="12" sm="3" lg="3">
                <v-text-field
                  v-model.trim="part.ebayCode"
                  :label="$t('parts.inventory.form.ebay_code')"
                  color="red-darken-1"
                  variant="solo"
                  readonly
                />
              </v-col>
              <!---------------------------------------NOTES--------------------------------------->
              <v-col cols="12" sm="4" lg="4">
                <v-text-field
                  v-model="part.notes"
                  :label="$t('parts.inventory.form.notes')"
                  color="red-darken-1"
                  variant="solo"
                  hide-details
                  readonly
                />
                <span
                  class="col-12 d-flex justify-end text-end ml-auto"
                  style="color: grey"
                  >{{
                    part.notes
                      ? "(" + part.notes.length + $t("characters") + ")"
                      : ""
                  }}</span
                >
              </v-col>
              <!----------------------------------------PRA---------------------------------------->
              <v-col cols="12" sm="4" lg="4">
                <v-text-field
                  v-model="part.pra"
                  :label="$t('parts.inventory.form.pra')"
                  color="red-darken-1"
                  variant="solo"
                  readonly
                />
              </v-col>
              <!---------------------------------------BRAND--------------------------------------->
              <v-col cols="12" sm="4" lg="4">
                <v-text-field
                  v-model="part.brand"
                  :label="$t('parts.inventory.form.brand')"
                  color="red-darken-1"
                  variant="solo"
                  readonly
                />
              </v-col>

              <v-col
                v-if="
                  Array.isArray(positionAlerts) &&
                  positionAlerts.length > 0
                "
                class="mt-0 pt-0"
                cols="12"
                sm="12"
                lg="12"
              >
                <div>
                  <v-icon
                    :color="getAlertColor(positionAlerts[0].type || 'info')"
                    size="18"
                    class="ml-1 cursor-pointer"
                  >
                    {{ getAlertIcon(positionAlerts[0].type || "info") }}
                  </v-icon>

                  <span>{{ $t(positionAlerts[0].reason) || "" }}</span>
                </div>
              </v-col>

              <!------------------------------------REPOSITORY------------------------------------->
              <v-col cols="6" lg="4">
                <v-select
                  v-model="repository"
                  :items="repositories"
                  :label="$t('parts.inventory.form.select_repository')"
                  color="red-darken-1"
                  variant="solo"
                  item-title="name"
                  return-object
                  readonly
                />
              </v-col>
              <!---------------------------------------ROOM---------------------------------------->
              <v-col cols="6" lg="3">
                <v-select
                  v-model="room"
                  :items="repository.rooms"
                  :label="$t('parts.inventory.form.select_room')"
                  color="red-darken-1"
                  variant="solo"
                  item-title="name"
                  return-object
                  readonly
                />
              </v-col>
              <!-------------------------------------LOCATION-------------------------------------->
              <v-col cols="4" lg="3">
                <v-select
                  v-model="location"
                  :items="room.locations"
                  :label="$t('parts.inventory.form.select_location')"
                  color="red-darken-1"
                  variant="solo"
                  item-title="code"
                  return-object
                  readonly
                />
              </v-col>
              <!------------------------------------POSITION X------------------------------------->
              <v-col cols="4" lg="1">
                <v-select
                  v-model="position_x"
                  :items="pos_x"
                  :label="$t('parts.inventory.form.select_x')"
                  color="red-darken-1"
                  variant="solo"
                  readonly
                />
              </v-col>
              <!------------------------------------POSITION Y------------------------------------->
              <v-col cols="4" lg="1">
                <v-select
                  v-model="position_y"
                  :items="pos_y"
                  :label="$t('parts.inventory.form.select_y')"
                  color="red-darken-1"
                  variant="solo"
                  readonly
                />
              </v-col>
              <!--------------------------------------QUALITY-------------------------------------->
              <v-col cols="9" sm="3" lg="3" md="3">
                <QualityRatingSelect
                  :model-value="selectedQualityRating"
                  :label="$t('parts.inventory.form.quality')"
                  readonly
                  :size="28"
                />
              </v-col>
              <!--------------------------------------CONDITION--------------------------------------->
              <v-col cols="6" sm="3" lg="2" md="3" class="part-export-col">
                <div class="part-export-field">
                  <div class="part-export-field__header">
                    {{ $t("parts.inventory.form.condition") }}
                  </div>
                  <v-checkbox
                    v-model="part.isNewPart"
                    :label="$t('parts.inventory.form.new')"
                    color="red-darken-3"
                    hide-details
                    density="compact"
                    class="part-export-field__checkbox"
                    readonly
                  />
                </div>
              </v-col>
              <!--------------------------------------EXPORT EBAY / RR--------------------------------------->
              <export-marketplaces
                v-model:export-ebay="part.exportEbay"
                v-model:rr-export="part.rrExport"
                :part-institution-rr="!!part.institution_id?.rr"
                readonly
                cols="6"
                sm="3"
                md="3"
                lg="3"
              />
              <v-col
                v-if="!showRrExport"
                cols="12"
                class="pa-0 ma-0"
                style="height: 0; min-height: 0"
              />
              <!---------------------------------------PRICE--------------------------------------->
              <!--PRICE-->
              <v-col
                cols="6"
                sm="4"
                :md="
                  $store.getters.institutionDisplayFeatures.partWeight ? 2 : 0
                "
              >
                <v-text-field
                  v-model="part.price"
                  :disabled="
                    $store.getters.role === 'User' ||
                    $store.getters.role === 'EbayOperator'
                  "
                  :label="$t('parts.inventory.form.price')"
                  variant="solo"
                  color="red-darken-1"
                  type="number"
                  step="0.01"
                  min="0"
                  oninput="validity.valid || (value = '')"
                  readonly
                />
              </v-col>
              <!--COST-->
              <v-col
                cols="6"
                sm="4"
                :md="
                  $store.getters.institutionDisplayFeatures.partWeight ? 2 : 0
                "
              >
                <v-text-field
                  v-model="part.cost"
                  :disabled="
                    $store.getters.role === 'User' ||
                    $store.getters.role === 'EbayOperator'
                  "
                  :label="$t('parts.inventory.form.cost')"
                  color="red-darken-1"
                  variant="solo"
                  type="number"
                  step="0.01"
                  min="0"
                  oninput="validity.valid || (value = '')"
                  readonly
                />
              </v-col>
              <!--INFOCAR REFERENCE PRICE-->
              <v-col
                cols="6"
                sm="4"
                :md="
                  $store.getters.institutionDisplayFeatures.partWeight ? 2 : 0
                "
              >
                <v-text-field
                  v-if="part.infoCar && part.infoCar.price"
                  v-model="part.infoCar.price"
                  :label="$t('parts.inventory.form.reference_price')"
                  color="red-darken-1"
                  variant="solo"
                  readonly
                />
                <v-text-field
                  v-else
                  :label="$t('parts.inventory.form.reference_price')"
                  color="red-darken-1"
                  variant="solo"
                  readonly
                />
              </v-col>
              <!--CURRENCY-->
              <v-col
                cols="12"
                sm="4"
                :md="
                  $store.getters.institutionDisplayFeatures.partWeight ? 2 : 0
                "
              >
                <v-select
                  v-model="part.currency"
                  :disabled="
                    $store.getters.role === 'User' ||
                    $store.getters.role === 'EbayOperator'
                  "
                  :items="currency"
                  :label="$t('parts.inventory.form.currency')"
                  color="red-darken-1"
                  variant="solo"
                  readonly
                />
              </v-col>
              <!--------------------------------------WEIGHT--------------------------------------->
              <v-col
                v-if="$store.getters.institutionDisplayFeatures.partWeight"
                cols="8"
                md="2"
              >
                <v-text-field
                  v-model="weight.value"
                  :label="$t('parts.inventory.form.weight')"
                  color="red-darken-1"
                  variant="solo"
                  type="number"
                  step="0.01"
                  min="0"
                  oninput="validity.valid || (value = '')"
                  readonly
                />
              </v-col>
              <v-col
                v-if="$store.getters.institutionDisplayFeatures.partWeight"
                cols="4"
                md="2"
              >
                <v-select
                  v-model="weight.unit"
                  :items="weightUnits"
                  :label="$t('parts.inventory.form.unit')"
                  color="red-darken-1"
                  variant="solo"
                  readonly
                />
              </v-col>
              <!-------------------------------------WARRANTY-------------------------------------->
              <v-col cols="12" sm="4">
                <v-select
                  v-model="part.warranty_id"
                  :disabled="
                    $store.getters.role === 'User' ||
                    $store.getters.role === 'EbayOperator'
                  "
                  :items="warranties"
                  :label="$t('parts.inventory.form.warranty')"
                  color="red-darken-1"
                  variant="solo"
                  :item-title="() => ''"
                  item-value="_id"
                  readonly
                >
                  <!-- Dropdown items -->
                  <template #item="{ props: itemProps, item }">
                    <v-list-item v-bind="itemProps">
                      {{ (item.raw.return_days ?? 0) / 86400 }}
                      {{ $t("warranties.days") }}
                    </v-list-item>
                  </template>

                  <!-- Selected value -->
                  <template #selection="{ item }">
                    <span v-if="item">
                      <!-- Find the selected warranty object -->
                      {{ (item.raw.return_days ?? 0) / 86400 }}
                      {{ $t("warranties.days") }}
                    </span>
                    <span v-else>
                      {{ $t("parts.inventory.form.warranty") }}
                    </span>
                  </template>
                </v-select>
              </v-col>
              <!---------------------------------MANUFACTURER CODE--------------------------------->
              <v-col cols="12" sm="4">
                <v-text-field
                  v-model="part.manufacturer_code"
                  :label="$t('parts.inventory.form.manufacturer_code')"
                  color="red-darken-1"
                  variant="solo"
                  readonly
                />
              </v-col>
              <!---------------------------------REPLACEMENT CODES--------------------------------->
              <v-col cols="12" sm="4">
                <v-text-field
                  v-if="part.infoCar && part.infoCar.replacementCodes"
                  v-model="part.infoCar.replacementCodes"
                  :label="$t('parts.inventory.form.replacement_codes')"
                  color="red-darken-1"
                  variant="solo"
                  readonly
                />
                <v-text-field
                  v-else
                  :label="$t('parts.inventory.form.replacement_codes')"
                  color="red-darken-1"
                  variant="solo"
                  readonly
                />
              </v-col>
              <!--------------------------------INSERTED OEM CODES--------------------------------->
              <!-- <v-col
                v-if="part.oemCodes && part.oemCodes.length > 0"
                cols="12"
                sm="6"
              >
                <div class="caption grey--text text--darken-1">
                  {{ $t("parts.insert_parts.form.oem_codes") }}
                </div>
                <v-chip v-for="(item, index) in part.oemCodes" :key="index">
                  {{ item }}
                  <v-icon right @click="removeOemCode(index)">
                    mdi-minus-circle-outline
                  </v-icon>
                </v-chip>
              </v-col> -->
              <v-col
                v-if="
                  $store.getters.institutionExportGoogleLeko ||
                  $store.getters.institutionExportEbayLeko
                "
                cols="12"
                md="12"
                class="mt-0 pt-0"
              >
                <h3>{{ $t("parts.inventory.form.shipping_costs") }}</h3>
              </v-col>
              <v-col
                v-if="$store.getters.institutionExportEbayLeko"
                cols="12"
                md="5"
                class="d-flex"
              >
                <h3 class="mr-3">Ebay</h3>
                <v-text-field
                  v-for="(value, country) in shippingCosts.ebay"
                  :key="'ebay-' + country"
                  v-model="shippingCosts.ebay[country]"
                  :label="`${country.toUpperCase()}`"
                  type="number"
                  variant="solo"
                  class="mr-2"
                  readonly
                />
              </v-col>
              <v-col
                v-if="$store.getters.institutionExportGoogleLeko"
                cols="12"
                md="5"
                class="d-flex"
              >
                <h3 class="mr-3">Google</h3>
                <v-text-field
                  v-for="(value, country) in shippingCosts.google"
                  :key="'google-' + country"
                  v-model="shippingCosts.google[country]"
                  :label="`${country.toUpperCase()}`"
                  type="number"
                  variant="solo"
                  class="mr-2"
                  readonly
                />
              </v-col>
              <v-col
                v-if="
                  ($store.getters.role == 'InstitutionAdmin' &&
                    $store.getters.rr_member == true) ||
                  $store.getters.role == 'LekoAdmin' ||
                  $store.getters.role == 'SuperAdmin'
                "
                cols="4"
                md="2"
                class="d-flex"
              >
                <h3 class="mr-3">ReteRicambi</h3>
                <v-text-field
                  v-model="shippingCosts.rr"
                  label="RR"
                  type="number"
                  variant="solo"
                  class="mr-2"
                  readonly
                />
              </v-col>
              <v-col
                v-if="$store.getters.institutionExportEbayLeko"
                cols="12"
                md="2"
                lg="4"
              >
                <v-select
                  v-model="part.weightRange"
                  :items="weightRanges"
                  :label="$t('parts.inventory.form.weight_range')"
                  color="red-darken-1"
                  variant="solo"
                  item-title="label"
                  item-value="value"
                  readonly
                />
              </v-col>
              <!------------------------------------PHOTO GRID------------------------------------->
              <v-col cols="12">
                <v-container grid-list-sm fluid>
                  <!--EXISTING PHOTOS-->
                  <v-row class="d-flex flex-nowrap" no-gutters>
                    <div
                      v-for="(image, index) in part.images"
                      :key="image.image"
                      class="shrink"
                    >
                      <v-card
                        flat
                        tile
                        draggable="true"
                        :data-index="index"
                        @dragstart="dragStartHandler"
                        @dragover.prevent
                        @drop="dropHandler"
                        @dragend="dragEndHandler"
                        @mouseenter="hoverIndex = index"
                        @mouseleave="hoverIndex = null"
                      >
                        <v-img
                          :src="`https://leko-tech.fra1.cdn.digitaloceanspaces.com/${image.thumb}`"
                          width="150px"
                          class="mx-1"
                        >
                          <v-row
                            v-if="hoverIndex === index"
                            class="ma-1 d-flex justify-space-between"
                          >
                            <v-icon
                              size="x-large"
                              color="primary"
                              class="pointer"
                              @click="viewImage('string', image)"
                            >
                              mdi-image
                            </v-icon>
                          </v-row>
                        </v-img>
                      </v-card>
                    </div>
                  </v-row>
                </v-container>
              </v-col>
            </v-row>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="red-darken-1" variant="outlined" @click="close">
          {{ $t("parts.inventory.form.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import getRequest from "../../api/getRequest";
import postRequest from "../../api/postRequest";
import QualityRatingSelect from "../common/QualityRatingSelect.vue";
import ExportMarketplaces from "@/components/common/ExportMarketplaces.vue";

export default {
  components: {
    QualityRatingSelect,
    "export-marketplaces": ExportMarketplaces,
  },
  props: ["hide"], // eslint-disable-line vue/require-prop-types
  data: () => ({
    draggingIndex: -1,
    dropIndex: -1,
    valid: false,
    dialog: false,
    loading: false,
    part: {},
    client: {},
    clients: [],
    currency: ["EUR"], // 'ALL'
    weight: { value: 0, unit: "kg" },
    weightUnits: ["kg"],
    infoCarCode: null,
    tests: [],
    warranties: [],
    shipments: [],
    qualities: [],
    repositories: [],
    repository: {},
    room: {},
    location: {},
    pos_x: [],
    pos_y: [],
    position_x: null,
    position_y: null,
    shippingCosts: {
      ebay: {
        it: null,
        de: "",
        fr: "",
        es: "",
      },
      google: {
        it: "",
        de: "",
        fr: "",
        es: "",
      },
      rr: "",
    },
    defaultCountries: ["it", "de", "fr", "es"],
    weightRanges: [
      { value: null, label: "Default" },
      { value: "0-2", label: "0-2 kg" },
      { value: "2,1-5", label: "2,1-5 kg" },
      { value: "5,1-10", label: "5,1-10 kg" },
      { value: "10,1-15", label: "10,1-15 kg" },
      { value: "15,1-25", label: "15,1-25 kg" },
      { value: "25,1-50", label: "25,1-50 kg" },
      { value: "50,1-75", label: "50,1-75 kg" },
      { value: "75,1-100", label: "75,1-100 kg" },
      { value: "100+", label: "100+ kg" },
      { value: "101,1-150", label: "101,1-150 kg" },
      { value: "150,1-200", label: "150,1-200 kg" },
      { value: "201,1-250", label: "201,1-250 kg" },
      { value: "250,1-300", label: "250,1-300 kg" },
    ],
    originalPart: null,
    oldShippings: null,
    externalColor: "",
    hoverIndex: null,
    image: {
      type: null,
      src: null,
      url: null,
    },
    imageValid: false,
    rotation: 0,
    img: null,
    dataFound: false,
    positionAlerts: [],
    foundCode: false,
    alert: {
      value: false,
      message: "",
      type: "error",
    },
  }),
  computed: {
    server() {
      return this.$serverUri;
    },
    showRrExport() {
      return (
        this.$store.getters.institutionRr === true ||
        this.part?.institution_id?.rr === true
      );
    },
    role() {
      return this.$store.getters.role;
    },
    hideDialog() {
      return this.$props.hide;
    },
    partID() {
      if (this.part.old_id && this.part.old_id !== undefined) {
        const id = this.part.old_id;
        return id.slice(id.length - 6, id.length);
      } else if (this.part._id && this.part._id !== undefined) {
        const id = this.part._id;
        return id.slice(id.length - 6, id.length);
      }
      return null;
    },
    selectedQualityRating() {
      if (!this.part.quality) return 0;
      if (
        typeof this.part.quality === "object" &&
        this.part.quality.rating != null
      ) {
        return this.part.quality.rating;
      }
      const match = this.qualities.find((q) => q._id === this.part.quality);
      return match ? match.rating : 0;
    },
  },
  watch: {
    hideDialog(value) {
      if (value) {
        this.dialog = false;
      } else {
        this.dialog = true;
      }
    },
    dialog(value) {
      if (value) {
        this.getClients();
        this.getWarranties();
        this.getRepositories();
        this.getShipments();
        this.getQualities();
      }
    },
    location(value) {
      this.generateCoordinates(value.position_x, value.position_y);
    },
    changeInfoCarCode(value) {
      if (!value) {
        this.validInfoCarCode = false;
        this.infoCarCode = null;
      }
    },
    searchInfoCarTitle(value) {
      if (value) {
        this.loadingCustomInfoCarTitle = true;
        getRequest(
          "/info-car/parts",
          `title=${value}&language=${this.$store.getters.language}&all=true`,
        )
          .then((response) => {
            this.infoCarTitles = response.parts;
          })
          .catch(() => {})
          .finally(() => {
            this.loadingCustomInfoCarTitle = false;
          });
      }
    },
    customInfoCarTitle(value) {
      if (value) {
        this.part.infoCar = {
          description: {
            descriptionCode: value.partCode,
            positionCode: "S000", // Can't determine the postition.
            descriptionId: value._id,
          },
        };
      } else {
        delete this.part.infoCar;
      }
    },
  },
  methods: {
    async open(data) {
      this.part = data;
      this.externalColor =
        data.car && data.car.externalColor ? data.car.externalColor : "";
      this.originalPart = JSON.parse(JSON.stringify(data));
      this.oldShippings = data.shippingCosts;
      this.shippingCosts = {
        ebay: {
          ...((this.shippingCosts && this.shippingCosts.ebay) || {}),
          ...((data.shippingCosts && data.shippingCosts.ebay) || {}),
        },
        google: {
          ...((this.shippingCosts && this.shippingCosts.google) || {}),
          ...((data.shippingCosts && data.shippingCosts.google) || {}),
        },
        rr:
          data.shippingCosts?.rr !== undefined
            ? data.shippingCosts.rr
            : this.shippingCosts?.rr || "",
      };
      if (data.weight) this.weight = data.weight;
      this.getRepository(data.repository_id);

      this.image = {
        type: null,
        src: null,
        url: null,
      };
      this.img = null;
      this.dataFound = false;
      if (
        data.alerts &&
        data.alerts.status == true &&
        data.alerts.mismatches &&
        data.alerts.mismatches.length > 0
      ) {
        this.positionAlerts = data.alerts.mismatches.filter(
          (a) => a?.field === "position",
        );
      }

      this.dialog = true;
    },
    close() {
      this.part = {};
      this.clients = [];
      this.warranties = [];
      this.repositories = [];
      this.qualities = [];
      this.weight = { value: 0, unit: "kg" };
      this.dialog = false;
      this.img = null;
      this.image = {
        type: null,
        src: null,
        url: null,
      };
      this.dataFound = false;
      this.loading = false;
      this.externalColor = "";
      this.shippingCosts = {
        ebay: {
          it: "",
          de: "",
          fr: "",
          es: "",
        },
        google: {
          it: "",
          de: "",
          fr: "",
          es: "",
        },
        rr: "",
      };
      this.$emit("close");
    },
    normalizeImages(images = []) {
      return images
        .map((img) => ({
          first: !!img.first,
          image: img.image || "",
          thumb: img.thumb || "",
        }))
        .sort((a, b) => (a.image + a.thumb).localeCompare(b.image + b.thumb)); // ensures consistent order
    },
    getClients() {
      getRequest(
        "/client/",
        `role=${this.$store.getters.role}&institution_id=${
          this.$store.getters.institutionId
        }`,
      )
        .then((response) => {
          this.clients = response.clients;
        })
        .catch(() => {});
    },
    getWarranties() {
      getRequest("/warranty/")
        .then((response) => {
          this.warranties = response.warranties;
        })
        .catch(() => {});
    },
    getShipments() {
      getRequest(
        "/shipment/",
        `role=${
          this.$store.getters.role
        }&institution_id=${this.$store.getters.institutionId}`,
      )
        .then((response) => {
          this.shipments = response.shipments;
        })
        .catch(() => {});
    },
    getRepository(id) {
      getRequest("/repository", `id=${id}`).then((response) => {
        this.repository = response.repository[0]; // eslint-disable-line prefer-destructuring
        this.repository.rooms.forEach((room) => {
          if (room._id === this.part.room_id) {
            this.room = room;
          }
        });
        this.room.locations.forEach((location) => {
          if (location._id === this.part.location_id) {
            this.location = location;
          }
        });
        this.location.shelves.forEach((shelf) => {
          if (shelf._id === this.part.shelf_id) {
            this.position_x = shelf.x;
            this.position_y = shelf.y;
          }
        });
      });
    },
    getRepositories() {
      getRequest(
        "/repository/",
        `role=${this.$store.getters.role}&institution_id=${
          this.$store.getters.institutionId
        }`,
      )
        .then((response) => {
          this.repositories = response.repositories;
        })
        .catch(() => {});
    },
    getQualities() {
      getRequest("/quality/")
        .then((response) => {
          this.qualities = response.qualities;
        })
        .catch(() => {});
    },
    generateCoordinates(x, y) {
      const xArr = [];
      const yArr = [];
      for (let _x = 1; _x <= x; _x += 1) {
        xArr.push(_x);
      }
      for (let _y = 1; _y <= y; _y += 1) {
        yArr.push(_y);
      }
      this.pos_x = xArr;
      this.pos_y = yArr;
      this.scannerPos_x = xArr;
      this.scannerPos_y = yArr;
    },
    getShelfId(x, y, cb) {
      if (this.location.shelves && this.location.shelves.length > 0) {
        this.location.shelves.forEach((shelf) => {
          if (shelf.x === x && shelf.y === y) {
            cb(shelf._id);
          }
        });
      } else {
        cb("");
      }
    },
    viewImage(type, data) {
      this.$emit("open-img-dialog", { type, data });
    },
    dragStartHandler(e) {
      this.draggingIndex = parseInt(
        e.currentTarget.getAttribute("data-index"),
        10,
      );
      e.dataTransfer.effectAllowed = "move";
      e.dataTransfer.setData("text/html", null);
    },
    dropHandler(e) {
      this.dropIndex = parseInt(e.currentTarget.getAttribute("data-index"), 10);
      if (this.draggingIndex !== this.dropIndex) {
        const draggedImage = this.part.images[this.draggingIndex];
        this.part.images.splice(this.draggingIndex, 1);
        this.part.images.splice(this.dropIndex, 0, draggedImage);
      }
      this.draggingIndex = -1;
      this.dropIndex = -1;
    },
    dragEndHandler() {
      this.draggingIndex = -1;
      this.dropIndex = -1;
    },
    getAlertIcon(type) {
      switch (type) {
        case "info":
          return "mdi-information";
        case "warning":
          return "mdi-alert-circle";
        case "error":
          return "mdi-close-octagon";
        default:
          return "";
      }
    },
    getAlertColor(type) {
      switch (type) {
        case "info":
          return "blue";
        case "warning":
          return "orange";
        case "error":
          return "red";
        default:
          return "";
      }
    },
  },
};
</script>
